class FooterMenuGroup extends HTMLElement {
  #desktopQuery = window.matchMedia('(min-width: 750px)');

  connectedCallback() {
    this.#desktopQuery.addEventListener('change', this.#syncMenuState);
    this.addEventListener('click', this.#handleSummaryClick);
    this.#syncMenuState();
  }

  disconnectedCallback() {
    this.#desktopQuery.removeEventListener('change', this.#syncMenuState);
    this.removeEventListener('click', this.#handleSummaryClick);
  }

  #syncMenuState = () => {
    this.querySelectorAll('.brand-footer__menu').forEach((menu, index) => {
      menu.open = this.#desktopQuery.matches || index === 0;
    });
  };

  #handleSummaryClick = (event) => {
    if (!this.#desktopQuery.matches || !event.target.closest('.brand-footer__menu > summary')) return;

    event.preventDefault();
  };
}

if (!customElements.get('footer-menu-group')) {
  customElements.define('footer-menu-group', FooterMenuGroup);
}
